module.exports = __webpack_public_path__ + "html/subscription_f8e45eaaaa4dc29e14b93d8ec50d2004.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription.html
// module id = py5d
// module chunks = 3 9